import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <h1 className="text-6xl font-bold text-accent">404</h1>
      <p className="mt-4 text-lg text-gray-600">Page not found</p>
      <Link
        to="/"
        className="mt-8 rounded-lg bg-accent px-6 py-3 text-white transition-colors hover:bg-accent-dark"
      >
        Back to Home
      </Link>
    </div>
  );
}
